// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const DynamicApplicationScanRunTriggerSchema = z.enum(['SCHEDULED','MANUAL'] as const);

export type DynamicApplicationScanRunTriggerType = `${z.infer<typeof DynamicApplicationScanRunTriggerSchema>}`

export default DynamicApplicationScanRunTriggerSchema;
